import cryptospirit from './alphaAssets/2/cryptospirit.png';
import dough from './alphaAssets/2/dough.png';
import fortune_feud from './alphaAssets/2/fortune_feud.png';
import lucy_in_the_sky from './alphaAssets/2/lucy_in_the_sky.png';
import profitpayout from './alphaAssets/2/profitpayout.png';

export const fantasyAlphaGamesData = [
    {
        game_details: {
            id: 126,
            game_num: 29,
            start_at: '2023-08-16T21:01:00Z',
            end_at: '2023-08-23T21:00:00Z',
            max_entries: 5000,
            value_cap: 100,
            entries_open_at: '2023-08-09T21:01:30Z',
            title: 'The Fortune Feud',
            rules_blurb: '',
            game_image_url: fortune_feud,
            game_code: 'cd42cbb1-4f81-4309-a6bd-0013080da94e',
            max_players: 2000,
            max_list_versions: 1000,
            min_version_interval_hrs: 0.08333,
            max_version_editable_hrs: 1,
            has_custom_lineups: false,
            total_prize_pool_usd: 3100,
            prizes_appraised_at: '2023-08-09T19:21:43Z',
        },
        top_lb: null,
        bottom_lb: null,
        user_lb: null,
    },
    {
        game_details: {
            id: 125,
            game_num: 28,
            start_at: '2023-08-09T21:01:00Z',
            end_at: '2023-08-16T21:00:00Z',
            max_entries: 5000,
            value_cap: 100,
            entries_open_at: '2023-08-02T21:01:30Z',
            title: 'Dough-nanza',
            rules_blurb: '',
            game_image_url: dough,
            game_code: '0af9d456-3a89-4e05-ad26-e859b4d07bf5',
            max_players: 2000,
            max_list_versions: 1000,
            min_version_interval_hrs: 0.08333,
            max_version_editable_hrs: 1,
            has_custom_lineups: false,
            total_prize_pool_usd: 3100,
            prizes_appraised_at: '2023-08-02T20:19:20Z',
        },
        top_lb: {
            player_name: '@TamashiiNations',
            current_portfolio_delta: 531.2361108282561,
            current_portfolio_delta_usd: 868547.0955338142,
            current_rank: 1,
        },
        bottom_lb: {
            player_name: 'Samrat',
            current_portfolio_delta: -177.49877401501698,
            current_portfolio_delta_usd: -311814.1105297992,
            current_rank: 624,
        },
        user_lb: null,
    },
    {
        game_details: {
            id: 92,
            game_num: 27,
            start_at: '2023-08-02T21:01:00Z',
            end_at: '2023-08-09T21:00:00Z',
            max_entries: 5000,
            value_cap: 100,
            entries_open_at: '2023-07-26T21:01:30Z',
            title: 'Profit Payout Party',
            rules_blurb: '',
            game_image_url: profitpayout,
            game_code: '121905ca-35d4-4dfa-b739-21dc01e93de7',
            max_players: 2000,
            max_list_versions: 1000,
            min_version_interval_hrs: 0.08333,
            max_version_editable_hrs: 1,
            has_custom_lineups: false,
            total_prize_pool_usd: 3100,
            prizes_appraised_at: '2023-07-26T20:45:16Z',
        },
        top_lb: {
            player_name: 'ThatMitch',
            current_portfolio_delta: 325.3988198857368,
            current_portfolio_delta_usd: 521497.6577663573,
            current_rank: 1,
        },
        bottom_lb: {
            player_name: 'Snowy42069',
            current_portfolio_delta: -72.68652157328528,
            current_portfolio_delta_usd: -141206.74632712954,
            current_rank: 522,
        },
        user_lb: null,
    },
    {
        game_details: {
            id: 91,
            game_num: 26,
            start_at: '2023-07-26T21:01:00Z',
            end_at: '2023-08-02T21:00:00Z',
            max_entries: 5000,
            value_cap: 100,
            entries_open_at: '2023-07-19T21:00:00Z',
            title: 'Lucy In The Sky',
            rules_blurb: 'Rules blurb',
            game_image_url: lucy_in_the_sky,
            game_code: 'f8ccfe9f-e9ed-40a4-99f6-b6850d86bd44',
            max_players: 2000,
            max_list_versions: 1000,
            min_version_interval_hrs: 0.08333,
            max_version_editable_hrs: 1,
            has_custom_lineups: false,
            total_prize_pool_usd: 2500,
            prizes_appraised_at: '2023-07-19T16:00:00Z',
        },
        top_lb: {
            player_name: 'synthlord#0013',
            current_portfolio_delta: 415.33157364883454,
            current_portfolio_delta_usd: 670573.3819404134,
            current_rank: 1,
        },
        bottom_lb: {
            player_name: 'skj1191',
            current_portfolio_delta: -63.91803414485262,
            current_portfolio_delta_usd: -129212.0869071085,
            current_rank: 285,
        },
        user_lb: null,
    },
    {
        game_details: {
            id: 90,
            game_num: 25,
            start_at: '2023-07-19T21:01:00Z',
            end_at: '2023-07-26T21:00:00Z',
            max_entries: 5000,
            value_cap: 100,
            entries_open_at: '2023-07-11T21:00:00Z',
            title: 'Crypto Spirit Quest',
            rules_blurb: 'Rules Blurb',
            game_image_url: cryptospirit,
            game_code: 'bdaa9d2a-d703-4478-82d5-a3361799efba',
            max_players: 2000,
            max_list_versions: 1000,
            min_version_interval_hrs: 0.08333,
            max_version_editable_hrs: 1,
            has_custom_lineups: false,
            total_prize_pool_usd: 2500,
            prizes_appraised_at: '2023-07-11T16:00:00Z',
        },
        top_lb: {
            player_name: 'Nareshupsc',
            current_portfolio_delta: 760.6888648466429,
            current_portfolio_delta_usd: 1235418.9693544612,
            current_rank: 1,
        },
        bottom_lb: {
            player_name: 'Uzair 2.0',
            current_portfolio_delta: -88.14309043608233,
            current_portfolio_delta_usd: -169790.97443267243,
            current_rank: 316,
        },
        user_lb: null,
    },
];

/*
import Compliance from './alphaAssets/Compliance.jpg';
import DoggyStyle from './alphaAssets/Doggy-Style.jpg';
import NoSecondBest from './alphaAssets/NoSecondBest.jpg';
import LoanMeADime from './alphaAssets/LoanMeADime.jpg';
import PonziGraveyard from './alphaAssets/PonziGraveyard.jpg';

export const fantasyAlphaGamesData = [
    {
        game_details: {
            id: 88,
            game_num: 23,
            start_at: '2023-07-04T21:00:00Z',
            end_at: '2023-07-10T21:00:00Z',
            max_entries: 500,
            value_cap: 100,
            entries_open_at: '2023-06-27T21:00:00Z',
            title: 'Loan Me a Dime',
            rules_blurb: '',
            game_image_url: LoanMeADime,
            game_code: '5f334b11-7d67-49e7-94a2-2ddb732acdd3',
            max_players: 2000,
            max_list_versions: 100,
            min_version_interval_hrs: 24,
            max_version_editable_hrs: 2,
            has_custom_lineups: true,
            total_prize_pool_usd: 2500,
            prizes_appraised_at: '2023-06-27T16:00:00Z'
        },
        top_lb: null,
        bottom_lb: null,
        user_lb: null
    },
    {
        game_details: {
            id: 87,
            game_num: 22,
            start_at: '2023-06-27T21:00:00Z',
            end_at: '2023-07-03T21:00:00Z',
            max_entries: 500,
            value_cap: 100,
            entries_open_at: '2023-06-20T21:00:00Z',
            title: 'No Second Best',
            rules_blurb: '',
            game_image_url: NoSecondBest,
            game_code: 'daa5aa73-555b-4ceb-a998-6bf138ac9dce',
            max_players: 2000,
            max_list_versions: 100,
            min_version_interval_hrs: 24,
            max_version_editable_hrs: 2,
            has_custom_lineups: true,
            total_prize_pool_usd: 2500,
            prizes_appraised_at: '2023-06-20T16:00:00Z'
        },
        top_lb: {
            player_name: 'Romique#1438',
            current_portfolio_delta: 181.33028220780474,
            current_portfolio_delta_usd: 280873.12985243683,
            current_rank: 1
        },
        bottom_lb: {
            player_name: 'Uzair 2.0',
            current_portfolio_delta: -73.66090669352664,
            current_portfolio_delta_usd: -146054.23042942447,
            current_rank: 329
        },
        user_lb: null
    },
    {
        game_details: {
            id: 86,
            game_num: 21,
            start_at: '2023-06-20T21:00:00Z',
            end_at: '2023-06-26T21:00:00Z',
            max_entries: 500,
            value_cap: 100,
            entries_open_at: '2023-06-13T21:00:00Z',
            title: 'The Compliance Contest',
            game_image_url: Compliance,
            game_code: '26d6cd52-4eee-4de2-8281-801f8c5d4bb7',
            max_players: 2000,
            max_list_versions: 100,
            min_version_interval_hrs: 24,
            max_version_editable_hrs: 2,
            has_custom_lineups: true,
            total_prize_pool_usd: 2500,
            prizes_appraised_at: '2023-06-13T16:00:00Z'
        },
        top_lb: {
            player_name: 'ThatMitch',
            current_portfolio_delta: 267.1659785341657,
            current_portfolio_delta_usd: 434131.8621719819,
            current_rank: 1
        },
        bottom_lb: {
            player_name: 'Uzair 2.0',
            current_portfolio_delta: -99.01946097978224,
            current_portfolio_delta_usd: -171719.21666545368,
            current_rank: 282
        },
        user_lb: null
    },
    {
        game_details: {
            id: 53,
            game_num: 20,
            start_at: '2023-06-13T21:00:00Z',
            end_at: '2023-06-19T21:00:00Z',
            max_entries: 500,
            value_cap: 100,
            entries_open_at: '2023-06-06T21:00:00Z',
            title: 'Doggy Style',
            rules_blurb: '',
            game_image_url: DoggyStyle,
            game_code: '2c8b2441-9d05-45ea-94a8-4fbbc03b8759',
            max_players: 2000,
            max_list_versions: 100,
            min_version_interval_hrs: 24,
            max_version_editable_hrs: 2,
            has_custom_lineups: true,
            total_prize_pool_usd: 2500,
            prizes_appraised_at: '2023-06-06T16:00:00Z'
        },
        top_lb: {
            player_name: 'MrYu#8671',
            current_portfolio_delta: 140.1277279896479,
            current_portfolio_delta_usd: 241321.89990739012,
            current_rank: 1
        },
        bottom_lb: {
            player_name: 'MarkusMeyer',
            current_portfolio_delta: -77.86574958308816,
            current_portfolio_delta_usd: -135491.25940037146,
            current_rank: 332
        },
        user_lb: null
    },
    {
        game_details: {
            id: 52,
            game_num: 19,
            start_at: '2023-06-06T21:00:00Z',
            end_at: '2023-06-12T21:00:00Z',
            max_entries: 500,
            value_cap: 100,
            entries_open_at: '2023-05-30T21:00:00Z',
            title: 'PONZI GRAVEYARD',
            rules_blurb: '',
            game_image_url: PonziGraveyard,
            game_code: '359471d0-aff9-45b9-bf25-12d7fec92afb',
            max_players: 2000,
            max_list_versions: 100,
            min_version_interval_hrs: 24,
            max_version_editable_hrs: 2,
            has_custom_lineups: true,
            total_prize_pool_usd: 3000,
            prizes_appraised_at: '2023-05-30T16:00:00Z'
        },
        top_lb: {
            player_name: 'ainfinity981#0323',
            current_portfolio_delta: 240.76199276397026,
            current_portfolio_delta_usd: 400689.5494537945,
            current_rank: 1
        },
        bottom_lb: {
            player_name: 'MarkusMeyer',
            current_portfolio_delta: -98.94243033973287,
            current_portfolio_delta_usd: -187351.92715060402,
            current_rank: 348
        },
        user_lb: null
    }
];
*/
